/**
 * JS-side mirror of the `--breakpoint-*` tokens in src/styles/tokens.css.
 *
 * Tailwind v4 has no JS config to import from, so this can't literally share a
 * value with the CSS. Instead breakpoints.test.ts parses tokens.css and fails
 * the build if the two ever disagree — same guarantee, enforced rather than
 * hoped for. Change a breakpoint in tokens.css, change it here, and the test
 * confirms you did both.
 */
export const BREAKPOINTS = {
  sm: 640, // large phones, landscape
  md: 768, // tablets
  lg: 1024, // small laptops — the sidebar drawer/rail threshold
  xl: 1280, // desktops
  '2xl': 1536,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;
